import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Adding and removing assets as collateral',
  description:
    'Allows you to decide whether to use a deposited asset as collateral. An asset used as collateral will affect your borrowing power and health factor.',
});
